import { Box, Switch, Typography } from '@mui/material';
import React from 'react';

interface RangeSliderToggleProps {
  show: boolean;
  onToggle: () => void;
}

export const RangeSliderToggle: React.FC<RangeSliderToggleProps> = ({
  show,
  onToggle,
}) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      width="100%"
      mt={0.5}
    >
      <Typography variant="body1">Afficher le curseur de plage</Typography>
      <Switch checked={show} onChange={onToggle} color="primary" />
    </Box>
  );
};
